import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {jobWriteSchema} from './jobWriteSchema';

/**
 * Document shape as stored in Firestore (jobs / jobsDev).
 * id comes from document id when reading.
 */
export const jobDbSchema = jobWriteSchema.extend({
  createdAt: firestoreTimestampSchema,
  updatedAt: firestoreTimestampSchema,
  startedAt: firestoreTimestampSchema.optional(),
  completedAt: firestoreTimestampSchema.optional(),
  metadata: z.record(z.string(), z.any()).optional(),
});

export type JobDb = z.infer<typeof jobDbSchema>;
